import { Navigate, Routes, Route, Outlet } from 'react-router-dom'

import ProjectDetailHeader from './Components/Header'
import ProjectInfoView from './Components/Info/View'
import Overview from './Components/Overview'
import AssetRequest from './Components/AssetRequest'
import AssetRequestForm from './Components/AssetRequestForm'
import ShippingRequest from './Components/ShippingRequest'
// import ResourceAuthorization from './Components/ResourceAuthorization'
// import ResourceAuthorizationForm from './Components/ResourceAuthorizationForm'
import Issue from './Components/Issue'
import ProjectMachineView from './Components/Machine'
import ProjectSiteSupervisorView from './Components/SiteSupervisor/View'
import ProjectSaleUsersView from './Components/Sales/View'
import ProjectEventLogListView from './Components/EventLog/List/View'

import useViewModel from './ViewModel'

const ProjectDetailView: React.FC = () => {
  const {
    id,
    pages,
    maintenance,
    shippingRequests,
    SHIPPING_REQUEST_COLUMN_CONFIGS,
    piles,
    ASSET_REQUEST_COLUMN_CONFIGS,
    projectData,
    openAssetRequestModal,
    handleOpenAssetRequestModal,
    handleCloseAssetRequestModal,
    isDownloadDailyReport,
    onDownloadDailyReport,
    // RESOURCE_AUTHORIZATION_COLUMN_CONFIGS,
    // resourceAuthorizationData,
    // openResourceAuthorizationModal,
    // handleOpenResourceAuthorizationModal,
    // handleCloseResourceAuthorizationModal,
    machineFormType,
    machineData,
    machines,
    MACHINE_TABLE_CONFIGS,
    machineFormState,
    isSubmittingAssignMachine,
    isOpenAssignMachineModal,
    onChangeMachineFormState,
    onStartAssignMachine,
    onStopAssignMachine,
    onSubmitAssignMachine,
  } = useViewModel()

  return (
    <Routes>
      <Route
        element={
          <>
            <ProjectDetailHeader
              project={projectData}
              pages={pages}
              isDownloadDailyReport={isDownloadDailyReport}
              onDownloadDailyReport={() => onDownloadDailyReport(projectData?.id)}
            />
            <Outlet />
          </>
        }>
        <Route
          path='overview'
          element={<Overview project={projectData} maintenance={maintenance} />}
        />
        <Route path='info' element={<ProjectInfoView />} />

        <Route
          path='shipping-request'
          element={
            <>
              <ShippingRequest
                columns={SHIPPING_REQUEST_COLUMN_CONFIGS}
                data={shippingRequests}
                projectData={projectData}
                onClickAdd={handleOpenAssetRequestModal}
              />
            </>
          }
        />

        <Route
          path='asset-request'
          element={
            <>
              <AssetRequest
                columns={ASSET_REQUEST_COLUMN_CONFIGS}
                data={piles}
                onClickAdd={handleOpenAssetRequestModal}
              />
              <AssetRequestForm
                isOpen={openAssetRequestModal}
                handleClose={handleCloseAssetRequestModal}
              />
            </>
          }
        />
        <Route path='event-log' element={<ProjectEventLogListView />} />

        {/* 
        <Route
          path='resource-authorization'
          element={
            <>
              <ResourceAuthorization
                columns={RESOURCE_AUTHORIZATION_COLUMN_CONFIGS}
                data={resourceAuthorizationData}
                onClickAdd={handleOpenResourceAuthorizationModal}
              />

              <ResourceAuthorizationForm
                isOpen={openResourceAuthorizationModal}
                handleClose={handleCloseResourceAuthorizationModal}
              />
            </>
          }
        /> */}

        <Route path='issue' element={<Issue />} />

        <Route
          path='machine'
          element={
            <ProjectMachineView
              machineData={machineData}
              machines={machines}
              MACHINE_TABLE_CONFIGS={MACHINE_TABLE_CONFIGS}
              formType={machineFormType}
              machineFormState={machineFormState}
              isSubmittingAssignMachine={isSubmittingAssignMachine}
              isOpenAssignMachineModal={isOpenAssignMachineModal}
              onChangeMachineFormState={onChangeMachineFormState}
              onStartAssignMachine={onStartAssignMachine}
              onStopAssignMachine={onStopAssignMachine}
              onSubmitAssignMachine={onSubmitAssignMachine}
            />
          }
        />

        <Route path='site-supervisor' element={<ProjectSiteSupervisorView />} />
        <Route path='sales' element={<ProjectSaleUsersView />} />

        <Route path='*' element={<Navigate to={`/project/${id}/overview`} />} />
      </Route>
    </Routes>
  )
}

export default ProjectDetailView
